import React from 'react';

import { FormattedMessage, injectIntl, InjectedIntl } from 'react-intl';
import { connect } from 'react-redux';

import { AutoDismissFlag } from '@atlaskit/flag';
import SuccessIcon from '@atlaskit/icon/glyph/check-circle';
import SimpleTag from '@atlaskit/tag/simple-tag';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { Branch } from 'src/components/types';
import { ComponentFlagId } from 'src/redux/flags/types';
import { BucketState } from 'src/types/state';

import messages from './create-branch-success-flag.i18n';

type Props = {
  id: ComponentFlagId | string;
  intl: InjectedIntl;
  branch: Branch | null | undefined;
};

const SuccessFlag = ({ id, branch, intl, ...otherProps }: Props) => {
  if (!branch) {
    return null;
  }

  return (
    <AutoDismissFlag
      {...otherProps}
      id={id}
      icon={
        <SuccessIcon
          label="Success"
          primaryColor={token('color.icon.success', colors.G300)}
        />
      }
      title={intl.formatMessage(messages.createBranchSuccessTitle)}
      description={
        <FormattedMessage
          {...messages.createBranchSuccessDescription}
          values={{ branchLabel: <SimpleTag text={branch.name} /> }}
        />
      }
      actions={[
        {
          content: (
            <a href={branch.links.html.href}>
              <FormattedMessage {...messages.createBranchSuccessLinkText} />
            </a>
          ),
          onClick: () => {},
        },
      ]}
    />
  );
};

const mapStateToProps = (state: BucketState) => {
  const {
    successFlag: { branch },
  } = state.createBranch;
  return { branch };
};

export const CreateBranchSuccessFlag = connect(mapStateToProps)(
  injectIntl(SuccessFlag)
);
